"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Library = void 0;
var expressions_1 = require("./expressions");
var Library = /** @class */ (function () {
    function Library(json, libraryManager) {
        this.source = json;
        // usings
        var usingDefs = (json.library.usings && json.library.usings.def) || [];
        this.usings = usingDefs
            .filter(function (u) { return u.localIdentifier !== 'System'; })
            .map(function (u) {
            return { name: u.localIdentifier, version: u.version };
        });
        // parameters
        var paramDefs = (json.library.parameters && json.library.parameters.def) || [];
        this.parameters = {};
        for (var _i = 0, paramDefs_1 = paramDefs; _i < paramDefs_1.length; _i++) {
            var param = paramDefs_1[_i];
            this.parameters[param.name] = new expressions_1.ParameterDef(param);
        }
        // code systems
        var csDefs = (json.library.codeSystems && json.library.codeSystems.def) || [];
        this.codesystems = {};
        for (var _a = 0, csDefs_1 = csDefs; _a < csDefs_1.length; _a++) {
            var codesystem = csDefs_1[_a];
            this.codesystems[codesystem.name] = new expressions_1.CodeSystemDef(codesystem);
        }
        // value sets
        var vsDefs = (json.library.valueSets && json.library.valueSets.def) || [];
        this.valuesets = {};
        for (var _b = 0, vsDefs_1 = vsDefs; _b < vsDefs_1.length; _b++) {
            var valueset = vsDefs_1[_b];
            this.valuesets[valueset.name] = new expressions_1.ValueSetDef(valueset);
        }
        // codes
        var codeDefs = (json.library.codes && json.library.codes.def) || [];
        this.codes = {};
        for (var _c = 0, codeDefs_1 = codeDefs; _c < codeDefs_1.length; _c++) {
            var code = codeDefs_1[_c];
            this.codes[code.name] = new expressions_1.CodeDef(code);
        }
        // concepts
        var conceptDefs = (json.library.concepts && json.library.concepts.def) || [];
        this.concepts = {};
        for (var _d = 0, conceptDefs_1 = conceptDefs; _d < conceptDefs_1.length; _d++) {
            var concept = conceptDefs_1[_d];
            this.concepts[concept.name] = new expressions_1.ConceptDef(concept);
        }
        // expressions
        var exprDefs = (json.library.statements && json.library.statements.def) || [];
        this.expressions = {};
        this.functions = {};
        for (var _e = 0, exprDefs_1 = exprDefs; _e < exprDefs_1.length; _e++) {
            var expr = exprDefs_1[_e];
            if (expr.type === 'FunctionDef') {
                if (!this.functions[expr.name]) {
                    this.functions[expr.name] = [];
                }
                this.functions[expr.name].push(new expressions_1.FunctionDef(expr));
            }
            else {
                this.expressions[expr.name] = new expressions_1.ExpressionDef(expr);
            }
        }
        // includes
        var inclDefs = (json.library.includes && json.library.includes.def) || [];
        this.includes = {};
        for (var _f = 0, inclDefs_1 = inclDefs; _f < inclDefs_1.length; _f++) {
            var incl = inclDefs_1[_f];
            if (libraryManager) {
                this.includes[incl.localIdentifier] = libraryManager.resolve(incl.path, incl.version);
            }
        }
        // Include codesystems from includes
        for (var iProperty in this.includes) {
            if (this.includes[iProperty] && this.includes[iProperty].codesystems) {
                for (var csProperty in this.includes[iProperty].codesystems) {
                    this.codesystems[csProperty] = this.includes[iProperty].codesystems[csProperty];
                }
            }
        }
    }
    Library.prototype.getFunction = function (identifier) {
        return this.functions[identifier];
    };
    Library.prototype.get = function (identifier) {
        return (this.expressions[identifier] || this.includes[identifier] || this.getFunction(identifier));
    };
    Library.prototype.getValueSet = function (identifier, libraryName) {
        if (this.valuesets[identifier] != null) {
            return this.valuesets[identifier];
        }
        return this.includes[libraryName] != null
            ? this.includes[libraryName].valuesets[identifier]
            : undefined;
    };
    Library.prototype.getCodeSystem = function (identifier) {
        return this.codesystems[identifier];
    };
    Library.prototype.getCode = function (identifier) {
        return this.codes[identifier];
    };
    Library.prototype.getConcept = function (identifier) {
        return this.concepts[identifier];
    };
    Library.prototype.getParameter = function (name) {
        return this.parameters[name];
    };
    return Library;
}());
exports.Library = Library;
//# sourceMappingURL=library.js.map